export default __webpack_public_path__ + "d6de05137de636335a8987e017f26025.svg";